<template>
  <section class="page">
    <div class="page__header">
      <div class="page__title">
        <SharedBreadcrumbs :breadcrumbs />

        <FaqSearch />
      </div>

      <h1 class="typography__headline1">Добавление и&nbsp;редактирование товара</h1>
    </div>

    <div class="page__content">
      <FaqArticlesAside :menu />

      <FaqArticlesContent>
        <div class="base-content-block">
          <FaqArticlesBlockHeading
            id="kak-popast"
            class="typography__headline2"
          >
            Как попасть
          </FaqArticlesBlockHeading>

          <div class="block-small">
            <p>Давайте добавим товары в&nbsp;ваш проект.</p>

            <p>
              В&nbsp;меню слева перейдите в&nbsp;раздел &laquo;Товары&raquo;. Если вы&nbsp;еще не&nbsp;добавляли
              товары&nbsp;&mdash; на&nbsp;появившейся странице нажмите &laquo;Добавить товар&raquo;.
            </p>
          </div>

          <FaqArticlesImageModalButton
            image-source="/images/faq/dobavlenie-i-redaktirovanie-tovara-1.jpg"
            @click="(imageSource) => (activeImageSource = imageSource)"
          />

          <p>
            Если вы&nbsp;уже добавляли товары&nbsp;&mdash; на&nbsp;появившейся странице нажмите &laquo;Добавить
            товар&raquo;.
          </p>

          <FaqArticlesImageModalButton
            image-source="/images/faq/dobavlenie-i-redaktirovanie-tovara-2.jpg"
            @click="(imageSource) => (activeImageSource = imageSource)"
          />
        </div>

        <div class="base-content-block">
          <FaqArticlesBlockHeading
            id="osnovnaya-informacija"
            class="typography__headline2"
          >
            Основная информация
          </FaqArticlesBlockHeading>

          <div class="block-small">
            <p>Название и&nbsp;описание обязательные для заполнения данные. Артикул заполняется по-желанию.</p>

            <p>
              Значок на&nbsp;карточке товара&nbsp;&mdash; визуальный тег для привлечения внимания, который увидит клиент
              в&nbsp;каталоге. Например, можно написать &laquo;Хит&raquo; или &laquo;Новинка&raquo;.
            </p>

            <p>Также нужно загрузить фотографию товара.</p>

            <p>
              Эти элементы будут использоваться в&nbsp;созданном сайте в&nbsp;каталоге товаров, поэтому лучше заполнять
              максимально подробно.
            </p>

            <p>
              Настройкой остатков товаров можно отслеживать сколько осталось и&nbsp;не&nbsp;давать заказать больше, чем
              есть. При выключенном состоянии товары можно будет заказать в&nbsp;любом количестве. По-умолчанию
              не&nbsp;активно.
            </p>

            <p>
              Настройкой активности можно быстро полностью скрывать товар с&nbsp;сайта из&nbsp;каталога. По-умолчанию
              активно.
            </p>
          </div>

          <FaqArticlesImageModalButton
            image-source="/images/faq/dobavlenie-i-redaktirovanie-tovara-3.jpg"
            @click="(imageSource) => (activeImageSource = imageSource)"
          />

          <div class="block-small">
            <p>
              При выборе категорий в&nbsp;появившемся окне выберите подходящие под этот товар и&nbsp;нажмите
              &laquo;Готово&raquo;.
            </p>

            <p>
              Если вы еще не настраивали категории —
              <BaseLink
                class="ui-link-secondary"
                target="_blank"
                to="/faq/articles/kategorii-tovarov"
                >самое время это сделать
              </BaseLink>.
            </p>
          </div>

          <FaqArticlesImageModalButton
            image-source="/images/faq/dobavlenie-i-redaktirovanie-tovara-4.jpg"
            @click="(imageSource) => (activeImageSource = imageSource)"
          />

          <p>
            В&nbsp;стоимости товара можно выставить скидку. Для этого нажмите на&nbsp;переключатель
            &laquo;Распродажа&raquo; и&nbsp;заполните цену со&nbsp;скидкой.
          </p>

          <FaqArticlesImageModalButton
            image-source="/images/faq/dobavlenie-i-redaktirovanie-tovara-5.jpg"
            @click="(imageSource) => (activeImageSource = imageSource)"
          />

          <FaqArticlesImageModalButton
            image-source="/images/faq/dobavlenie-i-redaktirovanie-tovara-6.jpg"
            @click="(imageSource) => (activeImageSource = imageSource)"
          />
        </div>

        <div class="base-content-block">
          <FaqArticlesBlockHeading
            id="galereya"
            class="typography__headline2"
          >
            Галерея
          </FaqArticlesBlockHeading>

          <div class="block-small">
            <p>
              В&nbsp;галерею услуги можно загрузить до&nbsp;10&nbsp;изображений в&nbsp;разрешении Jpeg, Jpg или Png,
              с&nbsp;максимальным весом 5&nbsp;Мб. Загружать можно разом несколько картинок.
            </p>

            <p>
              Эти элементы будут использоваться в&nbsp;созданном сайте в&nbsp;описании товара, поэтому важно
              их&nbsp;заполнить.
            </p>
          </div>

          <FaqArticlesImageModalButton
            image-source="/images/faq/dobavlenie-i-redaktirovanie-tovara-7.jpg"
            @click="(imageSource) => (activeImageSource = imageSource)"
          />

          <FaqArticlesImageModalButton
            image-source="/images/faq/dobavlenie-i-redaktirovanie-tovara-8.jpg"
            @click="(imageSource) => (activeImageSource = imageSource)"
          />
        </div>

        <div class="base-content-block">
          <FaqArticlesBlockHeading
            id="parametry"
            class="typography__headline2"
          >
            Параметры
          </FaqArticlesBlockHeading>

          <div class="block-small">
            <p>
              В&nbsp;параметрах необходимо указать все характеристики товара, которые вы&nbsp;хотите отразить
              на&nbsp;его странице.
            </p>

            <p>
              Эти элементы будут показываться на странице товара, использоваться для фильтрации по каталогу, а также для
              настройки вариантов товара.
            </p>

            <p>Нажмите &laquo;Добавить параметр&raquo;.</p>
          </div>

          <FaqArticlesImageModalButton
            image-source="/images/faq/dobavlenie-i-redaktirovanie-tovara-9.jpg"
            @click="(imageSource) => (activeImageSource = imageSource)"
          />

          <div class="block-small">
            <p>Заполните название и&nbsp;значение этого параметра.</p>

            <p>
              Если какое-то еще не&nbsp;добавляли&nbsp;&mdash; нажмите в&nbsp;самом низу на&nbsp;строку с&nbsp;кнопкой
              &laquo;Создать&raquo;.
            </p>
          </div>

          <FaqArticlesImageModalButton
            image-source="/images/faq/dobavlenie-i-redaktirovanie-tovara-10.jpg"
            @click="(imageSource) => (activeImageSource = imageSource)"
          />

          <FaqArticlesImageModalButton
            image-source="/images/faq/dobavlenie-i-redaktirovanie-tovara-11.jpg"
            @click="(imageSource) => (activeImageSource = imageSource)"
          />
        </div>

        <div class="base-content-block">
          <FaqArticlesBlockHeading
            id="varianty"
            class="typography__headline2"
          >
            Варианты
          </FaqArticlesBlockHeading>

          <div class="block-small">
            <p>В&nbsp;вариантах можно настроить варианты одного товара, отличные по&nbsp;каким-то параметрам.</p>

            <p>
              ВАЖНО! Информация (артикул, стоимость и&nbsp;остатки) и&nbsp;параметры, настраиваемые выше, уже сами собой
              представляют первый вариант этого товара. В&nbsp;блоке &laquo;Варианты&raquo; настраиваются другие
              варианты этого товара, отличные по&nbsp;нужным параметрам.
            </p>

            <p>Нажмите &laquo;Добавить вариант&raquo;.</p>
          </div>

          <FaqArticlesImageModalButton
            image-source="/images/faq/dobavlenie-i-redaktirovanie-tovara-12.jpg"
            @click="(imageSource) => (activeImageSource = imageSource)"
          />

          <div class="block-small">
            <p>Появится строка с&nbsp;добавленным новым вариантом, где будут выбраны все параметры.</p>

            <p>Нажмите &laquo;Изменить параметры&raquo; для их&nbsp;настройки.</p>
          </div>

          <FaqArticlesImageModalButton
            image-source="/images/faq/dobavlenie-i-redaktirovanie-tovara-13.jpg"
            @click="(imageSource) => (activeImageSource = imageSource)"
          />

          <p>
            В&nbsp;появившемся окне выберите параметры, по&nbsp;которым будут отличаться его варианты, и&nbsp;нажмите
            &laquo;Готово&raquo;.
          </p>

          <FaqArticlesImageModalButton
            image-source="/images/faq/dobavlenie-i-redaktirovanie-tovara-14.jpg"
            @click="(imageSource) => (activeImageSource = imageSource)"
          />

          <div class="block-small">
            <p>
              Теперь в&nbsp;добавленном варианте настраиваются только нужные поля и&nbsp;выбранные отличные параметры.
              Заполните&nbsp;их.
            </p>

            <p>Также справа можно быстро дублировать или удалить нужный.</p>

            <p>Если нужно добавить еще вариант&nbsp;&mdash; нажмите &quot;Добавить вариант&raquo;.</p>
          </div>

          <FaqArticlesImageModalButton
            image-source="/images/faq/dobavlenie-i-redaktirovanie-tovara-15.jpg"
            @click="(imageSource) => (activeImageSource = imageSource)"
          />

          <FaqArticlesImageModalButton
            image-source="/images/faq/dobavlenie-i-redaktirovanie-tovara-16.jpg"
            @click="(imageSource) => (activeImageSource = imageSource)"
          />
        </div>

        <div class="base-content-block">
          <FaqArticlesBlockHeading
            id="sposoby-dostavki"
            class="typography__headline2"
          >
            Способы доставки
          </FaqArticlesBlockHeading>

          <div class="block-small">
            <p>Нажмите &laquo;Выбрать способы&raquo;.</p>

            <p>Если вы&nbsp;еще не&nbsp;настраивали способы доставки&nbsp;&mdash;  <BaseLink
              class="ui-link-secondary"
              target="_blank"
              to="/faq/articles/sposoby-dostavki"
            >самое время это сделать
            </BaseLink>.</p>
          </div>

          <FaqArticlesImageModalButton
            image-source="/images/faq/dobavlenie-i-redaktirovanie-tovara-17.jpg"
            @click="(imageSource) => (activeImageSource = imageSource)"
          />

          <div class="block-small">
            <p>В&nbsp;окне выбора способов также можно быстро добавить новый.</p>

            <p>После выбора нужных способов нажмите &laquo;Готово&raquo;.</p>
          </div>

          <FaqArticlesImageModalButton
            image-source="/images/faq/dobavlenie-i-redaktirovanie-tovara-18.jpg"
            @click="(imageSource) => (activeImageSource = imageSource)"
          />

          <p>
            После выбора способов, вы&nbsp;увидите их&nbsp;с&nbsp;возможностью быстро удалить по&nbsp;крестику
            из&nbsp;списка ненужные.
          </p>

          <FaqArticlesImageModalButton
            image-source="/images/faq/dobavlenie-i-redaktirovanie-tovara-19.jpg"
            @click="(imageSource) => (activeImageSource = imageSource)"
          />
        </div>

        <div class="base-content-block">
          <FaqArticlesBlockHeading
            id="svязannyie-tovary-i-dobavlenie-tovara"
            class="typography__headline2"
          >
            Связанные товары и добавление товара
          </FaqArticlesBlockHeading>

          <div class="block-small">
            <p>Если вы&nbsp;добавляете первый товар&nbsp;&mdash; этого блока не&nbsp;будет.</p>

            <p>
              Связанные товары&nbsp;&mdash; товары, в&nbsp;которых в&nbsp;рекомендательном блоке появится текущий
              редактируемый товар.
            </p>

            <p>Нажмите &laquo;Выбрать товары&raquo;.</p>
          </div>

          <FaqArticlesImageModalButton
            image-source="/images/faq/dobavlenie-i-redaktirovanie-tovara-20.jpg"
            @click="(imageSource) => (activeImageSource = imageSource)"
          />

          <p>После выбора нужных связанных товаров нажмите &laquo;Готово&raquo;.</p>

          <FaqArticlesImageModalButton
            image-source="/images/faq/dobavlenie-i-redaktirovanie-tovara-21.jpg"
            @click="(imageSource) => (activeImageSource = imageSource)"
          />

          <div class="bock-small">
            <p>
              После выбора связанных товаров, вы&nbsp;увидите их&nbsp;с&nbsp;возможностью быстро удалить
              по&nbsp;крестику из&nbsp;списка ненужные.
            </p>

            <p>
              Как заполните всю нужную информацию о&nbsp;товаре, нажмите &laquo;Добавить&raquo; в&nbsp;самом низу
              страницы. После успешного добавления увидите в&nbsp;правом верхнем углу уведомление.
            </p>
          </div>

          <FaqArticlesImageModalButton
            image-source="/images/faq/dobavlenie-i-redaktirovanie-tovara-22.jpg"
            @click="(imageSource) => (activeImageSource = imageSource)"
          />
        </div>

        <div class="base-content-block">
          <FaqArticlesBlockHeading
            id="redaktirovanie-tovara"
            class="typography__headline2"
          >
            Редактирование товара
          </FaqArticlesBlockHeading>

          <div class="block-small">
            <p>
              После добавления товара, вы&nbsp;сможете найти его в&nbsp;<BaseLink
              class="ui-link-secondary"
                target="_blank"
                to="/faq/articles/spisok-tovarov-i-ikh-dannye"
                >списке товаров</BaseLink
              >.
            </p>

            <p>Отсюда можно быстро перейти к редактированию по иконке карандаша справа.</p>
          </div>

          <FaqArticlesImageModalButton
            image-source="/images/faq/dobavlenie-i-redaktirovanie-tovara-23.jpg"
            @click="(imageSource) => (activeImageSource = imageSource)"
          />

          <p>
            С добавлением товаров разобрались. Самое время перейти к изучению
            <BaseLink
              class="ui-link-secondary"
              to="/faq/articles/spisok-tovarov-i-ikh-dannye"
              >списка товаров и просмотра их данных</BaseLink
            >.
          </p>
        </div>
      </FaqArticlesContent>
    </div>

    <div class="page__related">
      <h2
        class="typography__headline2"
        v-html="t('pages.faq.otherArticles')"
      />

      <FaqArticlesList :articles="relatedArticles" />
    </div>
  </section>

  <LazyFaqArticlesImageModal
    v-if="isModalOpen(MODAL.FaqArticlesImage) && activeImageSource"
    :src="activeImageSource"
    @close="() => (activeImageSource = null)"
  />
</template>

<script lang="ts" setup>
const { t } = useI18n();
const { isModalOpen } = useModalStore();
const activeImageSource = ref<null | string>(null);

const breadcrumbs = [
  {
    name: t("pages.faq.title"),
    url: "/faq",
  },
  {
    name: "Заказы с товарами",
    url: "/faq/categories/zakazy-s-tovarami",
  },
  {
    name: "Добавление и&nbsp;редактирование товара",
  },
];

const menu = [
  {
    name: "Как&nbsp;попасть",
    url: "kak-popast",
  },
  {
    name: "Основная&nbsp;информация",
    url: "osnovnaya-informacija",
  },
  {
    name: "Галерея",
    url: "galereya",
  },
  {
    name: "Параметры",
    url: "parametry",
  },
  {
    name: "Варианты",
    url: "varianty",
  },
  {
    name: "Способы&nbsp;доставки",
    url: "sposoby-dostavki",
  },
  {
    name: "Связанные&nbsp;товары&nbsp;и&nbsp;добавление товара",
    url: "svязannyie-tovary-i-dobavlenie-tovara",
  },
  {
    name: "Редактирование&nbsp;товара",
    url: "redaktirovanie-tovara",
  },
];

const relatedArticles = [
  {
    name: "Способы доставки",
    slug: "sposoby-dostavki",
  },
  {
    name: "Категории товаров",
    slug: "kategorii-tovarov",
  },
  {
    name: "Список товаров и&nbsp;их данные",
    slug: "spisok-tovarov-i-ikh-dannye",
  },
  {
    name: "Цифровые товары",
    slug: "tsifrovye-tovary",
  },
  {
    name: "Список заказов и&nbsp;их данные",
    slug: "spisok-zakazov-i-ikh-dannye",
  },
  {
    name: "Добавление и&nbsp;редактирование заказа",
    slug: "dobavlenie-i-redaktirovanie-zakaza",
  },
];

useSeoMeta({
  title: "Добавление и редактирование товара",
});
</script>

<style scoped>
.page {
  display: flex;
  flex-direction: column;
  row-gap: 40px;
}

.page__header {
  display: flex;
  flex-direction: column;
  row-gap: 40px;
}

.page__title {
  display: flex;
  flex-direction: column;
  row-gap: 24px;
}

.page__content {
  display: flex;
  flex-direction: column;
  gap: 40px;
}

@media (--xl) {
  .page__content {
    flex-direction: row-reverse;
    justify-content: start;
    align-items: start;
  }
}

.page__related {
  display: flex;
  flex-direction: column;
  row-gap: 24px;
}
</style>
